import { BaseModel } from './base';

export enum PaymentRequestStatus {
  requested = 0,
  scheduled = 1,
  paid = 2,
  expired = 3,
  cancelled = 4,
}

export const PaymentRequestStatusLabels: Record<PaymentRequestStatus, string> = {
  [PaymentRequestStatus.requested]: 'api.models.paymentRequest.requested',
  [PaymentRequestStatus.scheduled]: 'api.models.paymentRequest.scheduled',
  [PaymentRequestStatus.paid]: 'api.models.paymentRequest.paid',
  [PaymentRequestStatus.expired]: 'api.models.paymentRequest.expired',
  [PaymentRequestStatus.cancelled]: 'api.models.paymentRequest.cancelled',
};

export class PaymentRequest extends BaseModel {
  idOrderPaymentRequest!: number;
  status!: PaymentRequestStatus;

  override objectID(): string | null {
    return this.idOrderPaymentRequest?.toString() ?? null;
  }

  get isStatusRequested(): boolean {
    return this.status === PaymentRequestStatus.requested;
  }

  get isStatusScheduled(): boolean {
    return this.status === PaymentRequestStatus.scheduled;
  }

  get isStatusPaid(): boolean {
    return this.status === PaymentRequestStatus.paid;
  }

  get isStatusExpired(): boolean {
    return this.status === PaymentRequestStatus.expired;
  }

  get isStatusCancelled(): boolean {
    return this.status === PaymentRequestStatus.cancelled;
  }
}
